import { get as getStoreValue } from "svelte/store";
import ProductTypesStore from "@shared/svelte/Stores/ProductTypesStore.js";
import * as _ from "lodash";
import { stagedRolloutCheck } from "@shared/svelte/Modules/StagedRolloutCheck.svelte";

const useCustomBoxLogic = () => !stagedRolloutCheck("sell_boxes_like_regular_containers");

let productSoldByValue = function (product, soldBy) {
  return soldBy || product.sold_by || (product.inventory || {}).sold_by;
};

export function isKeg(product) {
  return product.container_type == "keg";
}

export function isBox(product) {
  return product.container_type == "box";
}

export function soldInCases(product, productLine, soldBy = null) {
  if (!productLine) {
    return false;
  }
  if (!productLine.product_type_id) return true;

  if (useCustomBoxLogic()) {
    if (isBox(product) && !product.container_case_size) {
      return false;
    }
  }

  if (isKeg(product)) {
    return false;
  }

  var productSoldBy = productSoldByValue(product, soldBy);

  if (productSoldBy == "cases_only") {
    return true;
  }
  if (productSoldBy == "cases_and_units") {
    return true;
  }
  if (productSoldBy == "units_only") {
    return false;
  }

  let productTypes = getStoreValue(ProductTypesStore);
  const match = productTypes.types.find(t => t.id == productLine.product_type_id);
  return match.case;
}

export function soldInUnits(product, productLine, soldBy = null) {
  if (!productLine) {
    return false;
  }
  if (!_.get(productLine, "product_type_id")) return true;

  if (useCustomBoxLogic()) {
    if (isBox(product) && !!product.container_case_size) {
      return false;
    }
  }

  var productSoldBy = productSoldByValue(product, soldBy);

  if (isKeg(product)) {
    return false;
  }

  if (productSoldBy == "units_only" && !isKeg(product)) {
    return true;
  }
  if (productSoldBy == "cases_only") {
    return false;
  }
  if (productSoldBy == "cases_and_units" && !isKeg(product)) {
    return true;
  }

  let productTypes = getStoreValue(ProductTypesStore);
  const match = productTypes.types.find(t => t.id == productLine.product_type_id);
  return match.unit;
}

const orderProductUnitCount = orderProduct => {
  if (isKeg(orderProduct.product)) return orderProduct.unit_quantity;

  if (!soldInUnits(orderProduct.product, orderProduct.productLine)) {
    return orderProduct.case_quantity * (orderProduct.product.container_case_size || 1);
  }

  return (
    orderProduct.unit_quantity +
    (orderProduct.container_case_size || 1) * orderProduct.case_quantity
  );
};

export default { isBox, isKeg, soldInCases, soldInUnits, orderProductUnitCount };
